import memoizeWith from 'ramda/src/memoizeWith'
import getRecordSelector from 'root/src/client/logic/api/selectors/getRecordSelector'

import { GET_PROJECT } from 'root/src/shared/descriptions/endpoints/endpointIds'
import { getResponseLenses } from 'root/src/shared/descriptions/getEndpointDesc'

const responseLenses = getResponseLenses(GET_PROJECT)
const { pathOrGames } = responseLenses

export default memoizeWith(
	(state, props) => JSON.stringify(getRecordSelector(state, props)),
	(state, props) => pathOrGames([], getRecordSelector(state, props)),
)
